import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { logout } from '../../../features/auth/authSlice'

const Header = ({ logout, userAccess }) => {
  const handleLogout = () => {
    localStorage.clear()
    window.location.reload()
  }

  return (
    <div>
      <a href="#main-content" className="skip-link">Skip to content</a>
      <header className="appHeader">
        <div className="right dropdown">
          <button
            type="button"
            className="btn btn-icon"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="menu"
            aria-label="Account menu"
            id="account-menu-button"
          >
            <span className="bl-avatar">
              <ion-icon name="person-outline" aria-hidden="true"></ion-icon>
            </span>
          </button>

          <ul
            className="dropdown-menu dropdown-menu-end"
            aria-labelledby="account-menu-button"
          >
            <li>
              <Link className="dropdown-item" to="/appinfo">
                <ion-icon name="headset-outline" aria-hidden="true"></ion-icon>
                Support
              </Link>
            </li>

            {Array.isArray(userAccess) && userAccess.includes('ListUser') && (
              <li>
                <Link className="dropdown-item" to="/allusers">
                  <ion-icon name="people-circle-outline" aria-hidden="true"></ion-icon>
                  Users
                </Link>
              </li>
            )}

            <li>
              <Link className="dropdown-item" to="/msg">
                <ion-icon name="chatbox-outline" aria-hidden="true"></ion-icon>
                Messages
              </Link>
            </li>

            <li><hr className="dropdown-divider" /></li>

            <li>
              <button type="button" className="dropdown-item text-danger" onClick={handleLogout}>
                <ion-icon name="log-out-outline" aria-hidden="true"></ion-icon>
                Log out
              </button>
            </li>
          </ul>
        </div>
      </header>
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { userAccess } = auth
  return {
    userAccess
  }
}

const mapDispatchToProps = {
  logout
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
